<template>
    <i class="mdi mdi-star"></i>
</template>

<script>
    export default {
        name: 'StarIcon'
    }
</script>

<style>

</style>